import { Reveal, Eyebrow } from "./Reveal";

const chapters = [
  {
    n: "01",
    text: "Artificial Intelligence has transformed what technology can do.",
  },
  {
    n: "02",
    text: "We believe the next revolution is not making machines smarter — it is making people's lives better.",
  },
  {
    n: "03",
    text: "Our mission is to create intelligent products that support individuals through life's most challenging moments while preserving their independence, confidence, and dignity.",
  },
];

export default function Manifesto() {
  return (
    <section id="about" className="py-24 lg:py-32 bg-[#F9FAFB]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal>
          <Eyebrow number="01" label="About Huminence" />
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#111827] max-w-2xl">
            Human-Centered <span className="font-serif-italic text-[#7F9F43]">Intelligence.</span>
          </h2>
        </Reveal>

        <div className="mt-16 lg:mt-24 space-y-14 lg:space-y-20">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.08}>
              <div className="grid lg:grid-cols-12 gap-4 lg:gap-8 items-start border-t border-gray-200/80 pt-10">
                <span className="lg:col-span-2 font-mono text-sm text-[#E89A4D] font-semibold tracking-widest">
                  {c.n}
                </span>
                <p className="lg:col-span-8 lg:col-start-4 text-xl md:text-2xl lg:text-[1.7rem] font-light leading-snug text-[#111827]">
                  {c.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1}>
          <div className="mt-20 lg:mt-28 grid lg:grid-cols-12 gap-8 items-center">
            <div className="lg:col-span-5 rounded-3xl overflow-hidden card-soft">
              <img
                src="/assets/companionship.jpg"
                alt="Hands held gently in warm light"
                className="w-full h-64 lg:h-80 object-cover hover:scale-[1.03] transition-transform duration-700"
              />
            </div>
            <div className="lg:col-span-6 lg:col-start-7">
              <p className="text-gray-500 text-base md:text-lg leading-relaxed">
                Every product we build begins with one simple question:
              </p>
              <p className="mt-4 text-2xl md:text-3xl font-serif-italic text-[#111827]" data-testid="about-question">
                "How can technology make life more human?"
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
